module.exports = __webpack_public_path__ + "img/idcard_example_3.c9a3b34f.png";